import axios from 'axios';
import config from '../../config.json';

export const getHost = () => {
	if (localStorage.getItem('devserver') === '1') {
		return localStorage.getItem('devurl');
	}
	// if (process.env.REACT_APP_ASPNETCORE_ENVIRONMENT === "production") {
	//     return './';
	// }
	const loc = window.location;
	const prot = loc.protocol;
	let prod_env = process.env.REACT_APP_ASPNETCORE_ENVIRONMENT ? process.env.REACT_APP_ASPNETCORE_ENVIRONMENT : process.env.NODE_ENV;
	let prod_url = process.env.REACT_APP_ASPNETCORE_URL ? process.env.REACT_APP_ASPNETCORE_URL : loc.host;
	if (loc.host === 'visitor.eagleconsulting.co.in') {
		prod_env = 'production';
		prod_url = loc.host.replace('visitor', 'visitorapi');
	}
	return prot + '//' + (prod_env === 'production' ? prod_url : config.SERVER_URL_DEV);
};

export default (url, method, body) => {
	const options = {
		method: method || 'GET',
		url: `${getHost()}/${url}`,
		headers: defaultHeaders(),
		//withCredentials: true,
		data: body,
	};

	const res = axios(options);
	return parseStatus(res);
};

const parseStatus = (res) => {
	return new Promise((resolve, reject) => {
		res
			.then((response) => {
				const status = response.status;
				//console.log({ response, status });
				if (status) {
					if (status >= 200 && status < 300) {
						resolve(response.data);
					} else {
						reject(response.data);
					}
				} else {
					reject({ status: 500, response: response.message });
				}
			})
			.catch((reason) => {
				console.log(reason);

				return reject({ status: reason.status, response: reason.message });
			});
	});
};

const defaultHeaders = () => {
	return {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		'Access-Control-Allow-Origin': '*',
	};
};
